import { render, staticRenderFns } from "./ticket-history.vue?vue&type=template&id=43eff138&scoped=true&"
import script from "./ticket-history.vue?vue&type=script&lang=js&"
export * from "./ticket-history.vue?vue&type=script&lang=js&"
import style0 from "./ticket-history.vue?vue&type=style&index=0&id=43eff138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eff138",
  null
  
)

export default component.exports